module.exports = __webpack_public_path__ + "83747726a6526fd7b187ef566fd3b44a.jpg";